export default __webpack_public_path__ + "futsal-live.png";